import {
  MatrixBulkEditingContextProvider,
  MatrixNavigationContextProvider,
  useMatrixQuantitiesContext,
  useMatrixSettingsContext,
} from '@app/components/products/ProductMatrix/context';
import { useMatrixLayout } from '@app/utils/hooks/matrix/useMatrixLayout';
import { isDefined } from '@app/utils/is';
import { getHasValidConfigurator } from '@app/utils/matrix';
import React from 'react';

import { MatrixFooter } from '../MartixFooter';

import { MatrixBodyRow } from './MatrixBodyRow';

export const MatrixBody = React.memo(() => {
  const { cellQuantitiesMap } = useMatrixQuantitiesContext();
  const { isReadOnly, productConfiguration } = useMatrixSettingsContext();
  const { isTwoDimensional } = useMatrixLayout();

  const hasValidConfigurator = getHasValidConfigurator(productConfiguration);

  return (
    <MatrixNavigationContextProvider>
      <MatrixBulkEditingContextProvider>
        {cellQuantitiesMap.map((row, idx) => {
          const [firstRow] = row;
          const rowSum = row.reduce((acc, cell) => acc + cell.quantity, 0);
          if (rowSum === 0 && isReadOnly && !hasValidConfigurator && !isTwoDimensional) {
            return null;
          }

          if (!isDefined(firstRow)) {
            return null;
          }

          const { itemId, variantId } = firstRow;

          const key = `${variantId}-${itemId}`;

          return <MatrixBodyRow key={key} variantId={variantId} rowQuantities={row} rowIndex={idx} />;
        })}
        {/* footer placed inside body to fix copying */}
        <MatrixFooter />
      </MatrixBulkEditingContextProvider>
    </MatrixNavigationContextProvider>
  );
});
